@if (rows().length === 0) {
  <div class="empty-state">
    <div class="empty-state-icon">🔍</div>
    <p class="empty-state-title">No searches recorded yet</p>
    <p class="empty-state-message">
      Each import (database search, BibTeX upload, PDF upload, group corpus) is recorded here for
      reproducibility.
    </p>
  </div>
} @else {
  <div class="overflow-x-auto">
    <table class="w-full text-left text-sm">
      <thead>
        <tr class="border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500">
          <th class="px-3 py-2 font-semibold">Source</th>
          <th class="px-3 py-2 font-semibold">Query / terms</th>
          <th class="px-3 py-2 font-semibold">Filters</th>
          <th class="px-3 py-2 font-semibold">Search date</th>
          <th class="px-3 py-2 text-right font-semibold">Imported</th>
          <th class="px-3 py-2 text-right font-semibold">Removed - duplicates</th>
          <th class="px-3 py-2 text-right font-semibold">Removed - incomplete metadata</th>
          <th class="px-3 py-2 text-right font-semibold">Removed - undone</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track $index) {
          <tr class="border-b border-slate-100 align-top">
            <td class="px-3 py-2">
              <span class="badge badge-neutral">{{ row.sourceLabel }}</span>
            </td>
            <td class="px-3 py-2 text-slate-700">
              {{ row.query || '-' }}
            </td>
            <td class="px-3 py-2 text-slate-600">
              @if (row.workTypes.length || row.sourceTypes.length) {
                <span class="flex flex-wrap gap-1">
                  @for (wt of row.workTypes; track wt) {
                    <span class="badge badge-neutral">{{ wt }}</span>
                  }
                  @for (st of row.sourceTypes; track st) {
                    <span class="badge badge-neutral">{{ st }}</span>
                  }
                </span>
              } @else {
                <span class="text-slate-400">-</span>
              }
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-slate-600">
              {{ row.date ? (row.date | date: 'yyyy-MM-dd') : '-' }}
            </td>
            <td class="px-3 py-2 text-right tabular-nums text-slate-700">{{ row.imported }}</td>
            <td class="px-3 py-2 text-right tabular-nums text-slate-700">{{ row.duplicates }}</td>
            <td class="px-3 py-2 text-right tabular-nums text-slate-700">
              {{ row.incompleteMetadataRemoved }}
            </td>
            <td class="px-3 py-2 text-right tabular-nums text-slate-700">
              {{ row.undoneRemoved }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
